import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { computed, Ref, ref } from '@vue/composition-api';
import { useBehaviorData, useBehaviorOptions } from './../../../hooks/creation/adgroup/useBehavior/index';
import { i18n } from './../../../i18n';

export function useContainerProps(options: { adgroupData: Ref<AdgroupFormData> }) {
  const { adgroupData } = options;

  const { videoDay, videoActions, videoCategories } = useBehaviorData({
    adgroupData,
  });

  const _contentVisible = ref(false);

  const contentVisible = computed({
    get: () => _contentVisible.value,
    set: val => {
      _contentVisible.value = val;
    },
  });
  /** 是否需要追加 or 单词 */
  const needWordOr = computed(() => adgroupData.value.adTagV2.length > 0);

  /** 已经操作过（可能校验失败） */
  const hasOperated = computed(() =>
    Boolean(videoDay.value || videoActions.value.length || videoCategories.value.length)
  );

  /** 是否是默认的文案，只有收起且无操作时候才是默认 */
  const isDefaultText = computed(() => !(contentVisible.value || hasOperated.value));

  /** 标题 */
  const title = computed(() => {
    let temp = isDefaultText.value ?
      i18n.t('adgroup_target_interest_add_video_behaviors') :
      i18n.t('adgroup_target_interest_add_video_behaviors_title');
    if (needWordOr.value && !isDefaultText.value) {
      temp = `${i18n.t('adgroup_target_interest_word_or')} ${temp}`;
    }

    return temp;
  });

  /** 描述 */
  const desc = computed(() =>
    (isDefaultText.value ?
      i18n.t('adgroup_target_interest_add_video_behaviors_desc') :
      i18n.t('adgroup_target_interest_add_behaviors_selected_num', { num: videoCategories.value.length }))
  );

  return {
    contentVisible,
    hasOperated,
    title,
    desc,
  };
}

export function usePropsVideoBehaviorList(options: {
  campaignData: Ref<CampaignFormData>;
  adgroupData: Ref<AdgroupFormData>;
}) {
  const { campaignData, adgroupData } = options;
  const { videoBehaviorList } = useBehaviorOptions({
    campaignData,
    adgroupData,
  });

  return {
    videoBehaviorList,
  };
}
